import React from 'react'
import Navbar from "../components/Navbar";
import './SpatialHub.css';
const SpatialHub = () => {
  return (
    <>
      <Navbar />
      <div className="hub-container">
       <h5 className="hub-title">School of Spatial Computing</h5>
       <h5 className="subtitle1">Shaping the Future of Immersive Tech Talent</h5>
        <p>SpatialCT’s School of Spatial Computing is a learning and knowledge-sharing hub designed to empower students, educators, and professionals to master the tools, concepts, and innovations driving the XR revolution.</p> 
        <p className="coming-soon">Coming soon...</p>
      </div>
    </>
  )
}

export default SpatialHub  